import { ACCOUNT_PEP_BLOCK_QUERY, ACCOUNT_BLOCKS_QUERY, ACCOUNT_BLOCKS_UPDATED, ACCOUNT_PEP_DETAILS_UPDATED, ACCOUNT_PEP_BLOCK_UPDATED, ACCOUNT_PEP_DETAILS_QUERY } from '@gig/magic-messages';
import { __awaiter, __generator } from 'tslib';
import { magic } from '@gig/magic-sdk';
import { ActiveBlockReasonId } from '@gig/magic-sdk/dist/adapter/users/getUserActiveBlocks';

var PepBlockService = /** @class */ (function () {
    function PepBlockService() {
        this.blocks = [];
        this.detailsQuerySubscription = null;
        this.loading = false;
        this.registerEvents();
        this.subscribeToQueries();
        this.subscribeToUserBlocksChanges();
    }
    PepBlockService.prototype.subscribeToQueries = function () {
        var _this = this;
        window.queryBus.subscribe(ACCOUNT_PEP_BLOCK_QUERY, function () { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, window.queryBus.query(ACCOUNT_BLOCKS_QUERY)];
                    case 1:
                        _a.blocks = _b.sent();
                        return [2 /*return*/, this.isPepBlocked()];
                }
            });
        }); });
        this.subscribeDetailsQueries();
    };
    PepBlockService.prototype.subscribeToUserBlocksChanges = function () {
        var _this = this;
        window.eventBus.subscribe(ACCOUNT_BLOCKS_UPDATED, function (e) { return __awaiter(_this, void 0, void 0, function () {
            var isPepBlocked;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.blocks = (_a = e.payload) !== null && _a !== void 0 ? _a : [];
                        isPepBlocked = this.isPepBlocked();
                        window.eventBus.publish(ACCOUNT_PEP_BLOCK_UPDATED, isPepBlocked);
                        if (!isPepBlocked) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getPepDetails()];
                    case 1:
                        _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        this.pepDetails = undefined;
                        _b.label = 3;
                    case 3:
                        window.eventBus.publish(ACCOUNT_PEP_DETAILS_UPDATED, this.pepDetails);
                        return [2 /*return*/];
                }
            });
        }); }, { replay: true });
    };
    PepBlockService.prototype.getPepDetails = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.loading) {
                            return [2 /*return*/];
                        }
                        this.unsubscribeDetailsQueries();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        this.loading = true;
                        _a = this;
                        return [4 /*yield*/, magic.methods.users.getPepDetails()];
                    case 2:
                        _a.pepDetails = _b.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _b.sent();
                        // eslint-disable-next-line no-console
                        console.log('unable to get pep details', e_1);
                        return [3 /*break*/, 5];
                    case 4:
                        this.loading = false;
                        this.subscribeDetailsQueries();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    PepBlockService.prototype.unsubscribeDetailsQueries = function () {
        var _a;
        (_a = this.detailsQuerySubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        this.detailsQuerySubscription = null;
    };
    PepBlockService.prototype.subscribeDetailsQueries = function () {
        var _this = this;
        if (!this.detailsQuerySubscription) {
            this.detailsQuerySubscription = window.queryBus.subscribe(ACCOUNT_PEP_DETAILS_QUERY, function () {
                if (!_this.isPepBlocked()) {
                    return;
                }
                return _this.pepDetails;
            });
        }
    };
    PepBlockService.prototype.isPepBlocked = function () {
        return this.blocks.some(function (_a) {
            var blockReasonId = _a.blockReasonId;
            return blockReasonId === ActiveBlockReasonId.PoliticallyExposedPerson;
        });
    };
    PepBlockService.prototype.registerEvents = function () {
        window.queryBus.register(ACCOUNT_PEP_BLOCK_QUERY, {
            type: 'boolean',
        });
        window.queryBus.register(ACCOUNT_PEP_BLOCK_UPDATED, {
            type: 'boolean',
        });
    };
    return PepBlockService;
}());

export { PepBlockService };
